(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(wrap) {
      if (wrap.__cg) return;
      wrap.__cg = true;
      var grid = wrap.querySelector('.es-cgrid');
      var btns = wrap.querySelectorAll('.es-cnav');
      if (!grid || !btns.length) return;
      function state() {
        var max = grid.scrollWidth - grid.clientWidth - 2;
        btns[0].disabled = grid.scrollLeft <= 2;
        btns[1].disabled = grid.scrollLeft >= max;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var tile = grid.querySelector('.es-ctile');
          var step = tile ? tile.getBoundingClientRect().width + 20 : grid.clientWidth * 0.8;
          grid.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
        });
      });
      grid.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
    }
    function init() { document.querySelectorAll('[data-es-cgrid]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esPrev) return;
    window.__esPrev = true;

    var lb, img, count, list = [], idx = 0;
    function build() {
      lb = document.createElement('div');
      lb.className = 'es-prevlb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<img alt=""><button type="button" data-x aria-label="Fechar">×</button><button type="button" data-p aria-label="Anterior">‹</button><button type="button" data-n aria-label="Próxima">›</button><p class="es-prevlb__count"></p>';
      document.body.appendChild(lb);
      img = lb.querySelector('img');
      count = lb.querySelector('.es-prevlb__count');
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-x]') || e.target === lb) return close();
        if (e.target.closest('[data-p]')) return show(idx - 1);
        if (e.target.closest('[data-n]')) return show(idx + 1);
      });
      var sx = 0;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(idx + 1);
        if (e.key === 'ArrowLeft') show(idx - 1);
      });
    }
    function show(i) {
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      img.src = list[idx];
      count.textContent = (idx + 1) + ' / ' + list.length;
    }
    function open(root, i) {
      if (!lb) build();
      list = Array.prototype.map.call(root.querySelectorAll('[data-es-prev-img]'), function (b) { return b.dataset.full; });
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      show(i);
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      img.removeAttribute('src');
    }

    document.addEventListener('click', function (e) {
      var root = e.target.closest('[data-es-prev]');
      if (!root) return;
      var pic = e.target.closest('[data-es-prev-img]');
      if (pic) {
        var all = Array.prototype.slice.call(root.querySelectorAll('[data-es-prev-img]'));
        return open(root, all.indexOf(pic));
      }
      var go = e.target.closest('[data-es-prev-go]');
      if (go) return open(root, parseInt(go.dataset.esPrevGo, 10) || 0);
      var btn = e.target.closest('[data-es-prev-btn]');
      if (btn) {
        var cls = btn.dataset.mode === 'app' ? 'is-all' : 'is-open';
        var isOpen = !root.classList.contains(cls);
        root.classList.toggle(cls, isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        btn.textContent = isOpen ? btn.dataset.less : btn.dataset.more;
        if (isOpen && cls === 'is-all') {
          var f = root.querySelector('.es-prev__all iframe');
          if (f && f.src && f.getBoundingClientRect().height < 60) {
            var u = f.src;
            f.src = 'about:blank';
            setTimeout(function () { f.src = u; }, 60);
          }
        }
        if (!isOpen) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;

    /* ---------- Lightbox único da página ---------- */
    var lb;
    function icon(d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>'; }
    function getLB() {
      if (lb) return lb;
      var el = document.createElement('div');
      el.className = 'es-lb';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Mídia ampliada');
      el.innerHTML =
        '<div class="es-lb__bg" data-close></div>' +
        '<button type="button" class="es-lb__btn es-lb__close" data-close aria-label="Fechar">' + icon('M6 6l12 12M18 6L6 18') + '</button>' +
        '<button type="button" class="es-lb__btn es-lb__prev" data-prev aria-label="Anterior">' + icon('M15 5l-7 7 7 7') + '</button>' +
        '<div class="es-lb__stage"></div>' +
        '<button type="button" class="es-lb__btn es-lb__next" data-next aria-label="Próximo">' + icon('M9 5l7 7-7 7') + '</button>' +
        '<div class="es-lb__count"></div>' +
        '<div class="es-lb__foot"></div>';
      document.body.appendChild(el);
      lb = { el: el, stage: el.querySelector('.es-lb__stage'), count: el.querySelector('.es-lb__count'), foot: el.querySelector('.es-lb__foot'), items: [], i: 0, cf: null };
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) close();
        else if (e.target.closest('[data-prev]')) show(lb.i - 1);
        else if (e.target.closest('[data-next]')) show(lb.i + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(lb.i - 1);
        if (e.key === 'ArrowRight') show(lb.i + 1);
      });
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 50) show(lb.i + (dx < 0 ? 1 : -1));
      });
      return lb;
    }
    function show(i) {
      if (i < 0 || i >= lb.items.length) return;
      lb.i = i;
      var item = lb.items[i];
      var old = lb.stage.querySelector('video');
      if (old) old.pause();
      lb.stage.innerHTML = '';
      var v = item.querySelector('video');
      var img = item.querySelector('.es-cf__media img, .es-show__media > img');
      if (v) {
        var big = document.createElement('video');
        big.src = v.dataset.hd || v.dataset.src;
        big.poster = v.poster;
        big.controls = true;
        big.playsInline = true;
        big.setAttribute('playsinline', '');
        big.loop = true;
        lb.stage.appendChild(big);
        var p = big.play();
        if (p && p.catch) p.catch(function () { big.muted = true; big.play(); });
      } else if (img) {
        var im = document.createElement('img');
        var btn = item.querySelector('[data-full]');
        im.src = (btn && btn.getAttribute('data-full')) || img.currentSrc || img.src;
        im.alt = img.alt || '';
        lb.stage.appendChild(im);
      }
      lb.foot.innerHTML = '';
      var prod = item.querySelector('.es-tile__prod');
      if (prod) lb.foot.appendChild(prod.cloneNode(true));
      lb.count.textContent = lb.items.length > 1 ? (i + 1) + ' / ' + lb.items.length : '';
      lb.el.querySelector('[data-prev]').disabled = i === 0;
      lb.el.querySelector('[data-next]').disabled = i === lb.items.length - 1;
    }
    function open(cf, i) {
      getLB();
      lb.items = cf.items;
      lb.cf = cf;
      cf.pauseAll();
      lb.el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      show(i);
      lb.el.querySelector('.es-lb__close').focus({ preventScroll: true });
    }
    function close() {
      var v = lb.stage.querySelector('video');
      if (v) v.pause();
      lb.stage.innerHTML = '';
      lb.el.hidden = true;
      document.documentElement.style.overflow = '';
      if (lb.cf) { lb.cf.go(lb.i, true); lb.cf.resume(); }
    }

    /* ---------- Carrossel em camadas ---------- */
    function setup(root) {
      if (root.__esCf) return;
      root.__esCf = true;
      var track = root.querySelector('[data-es-cf-track]');
      var dots = root.querySelector('[data-es-cf-dots]');
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      var active = -1, ticking = false, visible = false;

      items.forEach(function (it, i) {
        if (items.length < 2) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir para o item ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });

      function go(i, instant) {
        var it = items[i];
        if (!it) return;
        var left = it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2;
        track.scrollTo({ left: left, behavior: instant || reduce ? 'auto' : 'smooth' });
      }
      function playActive() {
        items.forEach(function (it, k) {
          var v = it.querySelector('video');
          if (!v) return;
          if (k === active && visible && !save && !reduce) {
            if (!v.getAttribute('src')) v.src = v.dataset.src;
            v.muted = true;
            var p = v.play();
            if (p && p.then) p.then(function () { it.classList.add('is-playing'); }).catch(function () {});
          } else {
            v.pause();
            it.classList.remove('is-playing');
          }
        });
      }
      function update() {
        ticking = false;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        items.forEach(function (it, i) {
          var w = it.offsetWidth;
          var d = (it.offsetLeft + w / 2 - center) / w;
          var a = Math.min(Math.abs(d), 2.5);
          var c = Math.max(-2, Math.min(2, d));
          var s = 1 - Math.min(a, 2) * 0.09;
          var rot = Math.max(-34, Math.min(34, -c * 24));
          it.style.transform = 'perspective(900px) translateX(' + (-c * w * 0.22).toFixed(1) + 'px) rotateY(' + rot.toFixed(1) + 'deg) scale(' + s.toFixed(3) + ')';
          it.style.zIndex = String(100 - Math.round(a * 10));
          var shade = Math.min(a, 1.5) * 0.22;
          it.style.setProperty('--shade-l', (d > 0 ? shade : shade * 0.35).toFixed(2));
          it.style.setProperty('--shade-r', (d > 0 ? shade * 0.35 : shade).toFixed(2));
          if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = i; }
        });
        if (best !== active) {
          active = best;
          items.forEach(function (it, k) { it.classList.toggle('is-active', k === active); });
          Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === active); });
          playActive();
        }
      }
      var settle;
      function request() {
        root.classList.add('is-dragging');
        clearTimeout(settle);
        settle = setTimeout(function () { root.classList.remove('is-dragging'); }, 120);
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }

      track.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      track.addEventListener('click', function (e) {
        var it = e.target.closest('.es-cf__item');
        if (!it) return;
        var i = items.indexOf(it);
        if (i !== active) { e.preventDefault(); go(i); return; }
        if (e.target.closest('[data-es-cf-open]')) open(api, i);
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; playActive(); }, { threshold: 0.25 }).observe(root);
      } else {
        visible = true;
      }

      var api = {
        items: items,
        go: go,
        pauseAll: function () { items.forEach(function (it) { var v = it.querySelector('video'); if (v) v.pause(); it.classList.remove('is-playing'); }); },
        resume: playActive
      };

      var start = items.length >= 3 ? Math.floor((items.length - 1) / 2) : 0;
      requestAnimationFrame(function () { go(start, true); update(); });
    }

    /* ---------- Mostruário ---------- */
    function setupShow(root) {
      if (root.__esShow) return;
      root.__esShow = true;
      var track = root.querySelector('[data-es-show-track]');
      var items = Array.prototype.slice.call(root.querySelectorAll('.es-show__item'));
      if (!items.length) return;
      var api = {
        items: items,
        go: function () {},
        pauseAll: function () { items.forEach(function (it) { var v = it.querySelector('video'); if (v) v.pause(); }); },
        resume: function () {
          items.forEach(function (it) {
            var v = it.querySelector('video');
            if (!v || !v.getAttribute('src')) return;
            var r = it.getBoundingClientRect();
            if (r.right < 0 || r.left > window.innerWidth || r.bottom < 0 || r.top > window.innerHeight) return;
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          });
        }
      };
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-es-show-open]');
        if (!b) return;
        open(api, items.indexOf(b.closest('.es-show__item')));
      });
      var prev = root.querySelector('[data-es-show-prev]');
      var next = root.querySelector('[data-es-show-next]');
      if (prev && next) {
        var stepW = function () { return items[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 16); };
        var sync = function () {
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        };
        prev.addEventListener('click', function () { track.scrollBy({ left: -stepW(), behavior: reduce ? 'auto' : 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: stepW(), behavior: reduce ? 'auto' : 'smooth' }); });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      }
    }

    function init() {
      document.querySelectorAll('[data-es-cf]').forEach(setup);
      document.querySelectorAll('[data-es-show]').forEach(setupShow);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essenza-product-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('essenza-reviews')) return;

  const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ESC[c]);
  const sized = (u, n) => (/[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, `$1width=${n}`) : `${u}${u.includes('?') ? '&' : '?'}width=${n}`);
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  const COUNT = '<svg viewBox="0 0 24 24"><rect x="3" y="6" width="14" height="14" rx="2"/><path d="M7 3h12a2 2 0 0 1 2 2v12"/></svg>';
  const PLAY = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  const still = (m) => (m ? (m.t === 'v' ? m.p : m.u) : '');

  class EssenzaReviews extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.data = [];
      this.cfg = {};
      try {
        this.cfg = JSON.parse(this.querySelector('script[data-er-data]').textContent.replace(/&(lt|amp);/g, (m, c) => (c === 'lt' ? '<' : '&')));
        this.data = this.cfg.items || [];
      } catch (err) { /* sem dados: mantém os cartões do servidor */ }
      if (!this.data.length) return;

      this.els = new Map();
      this.querySelectorAll('[data-er-card]').forEach((c) => this.els.set(Number(c.dataset.erI), c));
      this.step = Math.max(1, parseInt(this.dataset.initial, 10) || 8);
      this.shown = this.step;
      this.filter = 'all';
      this.matching = [];
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.grid = this.querySelector('[data-er-grid]');
      this.foot = this.querySelector('[data-er-foot]');
      this.moreBtn = this.querySelector('[data-er-more]');
      this.status = this.querySelector('[data-er-status]');
      this.progress = this.querySelector('[data-er-progress]');
      this.swipe = this.querySelector('[data-er-swipe]');
      this.swipeText = this.querySelector('[data-er-swipe-text]');
      this.swipeCount = this.querySelector('[data-er-swipe-count]');
      this.dialog = this.querySelector('.er-lb');
      this.stage = this.querySelector('[data-er-stage]');
      this.info = this.querySelector('[data-er-info]');
      this.counter = this.querySelector('[data-er-counter]');

      this.addEventListener('click', (e) => this.onClick(e));
      this.mobile.addEventListener?.('change', () => this.render(false));
      this.grid.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.target.tagName === 'VIDEO') return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
      });
      this.dialog.addEventListener('close', () => {
        this.stage.replaceChildren();
        document.documentElement.style.removeProperty('overflow');
        this.opener?.focus({ preventScroll: true });
      });
      this.bindSwipe();
      this.render(false);
      requestAnimationFrame(() => this.checkClamp());
      window.addEventListener('resize', () => { clearTimeout(this._rz); this._rz = setTimeout(() => this.checkClamp(), 150); });
    }

    matches(i) {
      const it = this.data[i];
      if (this.filter === 'all') return true;
      if (this.filter === 'photos') return it.m.length > 0;
      return String(it.r) === this.filter;
    }

    // ---- HTML dos cartões (espelha o markup do servidor) ----
    metaHtml(it) {
      const date = it.f ? `<time class="er-card__date" datetime="${esc(it.d)}">${esc(it.f)}</time>` : '';
      return `<div class="er-card__meta"><span class="er-stars" style="--fill:${it.r * 20}%" role="img" aria-label="Nota ${it.r} de 5"></span>${date}</div>`;
    }

    textHtml(it) {
      return `<p class="er-card__text">${esc(it.b).replace(/\r?\n/g, '<br>')}</p>`;
    }

    authorHtml(it) {
      let avatar = `<span class="er-card__avatar" aria-hidden="true">${esc(it.a)}</span>`;
      if (this.cfg.avatar) {
        const src = still(it.m[1] || it.m[0]);
        if (src) avatar = `<span class="er-card__avatar er-card__avatar--photo" aria-hidden="true"><img src="${esc(sized(src, 96))}" width="40" height="40" alt="" loading="lazy"></span>`;
      }
      const tag = this.cfg.tag ? `<span class="er-card__sub er-card__sub--tag">${this.cfg.icon ? CHECK : ''}${esc(this.cfg.tag)}</span>` : '';
      return `<footer class="er-card__author">${avatar}<span class="er-card__who"><span class="er-card__name-row"><span class="er-card__name">${esc(it.n)}</span></span>${tag}</span></footer>`;
    }

    cardHtml(i) {
      const it = this.data[i];
      const cover = still(it.m[0]);
      const n = it.m.length;
      let media = '';
      if (cover) {
        const srcset = [300, 450, 600, 900].map((w) => `${sized(cover, w)} ${w}w`).join(', ');
        media = `<button type="button" class="er-card__media" data-er-open="${i}" data-er-media="0" aria-label="Ver ${n} ${n === 1 ? 'foto' : 'fotos'} de ${esc(it.n)}"><img src="${esc(sized(cover, 900))}" srcset="${esc(srcset)}" sizes="(min-width: 1200px) 290px, (min-width: 750px) 45vw, 80vw" alt="" class="er-card__img" loading="lazy">${it.m[0].t === 'v' ? `<span class="er-card__play" aria-hidden="true">${PLAY}</span>` : ''}${n > 1 ? `<span class="er-card__count" aria-hidden="true">${COUNT}${n}</span>` : ''}</button>`;
      }
      const quote = cover ? '' : '<span class="er-card__quote" aria-hidden="true">&ldquo;</span>';
      return `<article class="er-card${cover ? '' : ' er-card--text'}" data-er-card data-er-i="${i}" data-rating="${it.r}" data-photos="${n > 0}">${media}<div class="er-card__body">${this.metaHtml(it)}${quote}${this.textHtml(it)}<button type="button" class="er-card__more" data-er-expand hidden>Ler mais</button>${this.authorHtml(it)}</div></article>`;
    }

    card(i) {
      let el = this.els.get(i);
      if (!el) {
        const t = document.createElement('template');
        t.innerHTML = this.cardHtml(i);
        el = t.content.firstElementChild;
        this.els.set(i, el);
      }
      return el;
    }

    render(reset = true) {
      this.matching = [];
      this.data.forEach((_, i) => { if (this.matches(i)) this.matching.push(i); });
      const total = this.matching.length;
      if (reset) this.grid.replaceChildren();
      this.matching.slice(0, this.shown).forEach((i) => {
        const el = this.card(i);
        if (el.parentNode !== this.grid) this.grid.append(el);
      });
      const visible = Math.min(this.shown, total);
      this.foot.hidden = total <= this.step;
      this.moreBtn.hidden = visible >= total;
      this.status.textContent = `Mostrando ${visible} de ${total} ${total === 1 ? 'avaliação' : 'avaliações'}`;
      if (reset) this.grid.scrollLeft = 0;
      this.updateProgress();
      this.checkClamp();
    }

    onScroll() {
      const g = this.grid;
      if (this.mobile.matches && this.shown < this.matching.length && g.scrollLeft + g.clientWidth >= g.scrollWidth - g.clientWidth) {
        this.shown += this.step;
        this.render(false);
        return;
      }
      this.updateProgress();
    }

    updateProgress() {
      if (!this.progress || !this.mobile.matches) return;
      const g = this.grid;
      const total = this.matching.length;
      const max = g.scrollWidth - g.clientWidth;
      const ratio = g.clientWidth / Math.max(g.scrollWidth, 1);
      const w = Math.max(ratio * 100, 12);
      const pos = max > 0 ? g.scrollLeft / max : 0;
      this.progress.style.width = `${w}%`;
      this.progress.style.transform = `translateX(${pos * (100 / w * 100 - 100)}%)`;
      const cards = [...g.children];
      if (this.swipe) {
        this.swipe.hidden = total < 2;
        const stepW = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
        const idx = Math.min(total, Math.round(g.scrollLeft / Math.max(stepW, 1)) + 1);
        const end = max > 0 && g.scrollLeft >= max - 4 && cards.length >= total;
        this.swipe.classList.toggle('is-end', end);
        this.swipeText.textContent = end ? this.swipeText.dataset.end : this.swipeText.dataset.default;
        this.swipeCount.textContent = `${end ? total : idx} / ${total}`;
      }
    }

    checkClamp() {
      [...this.grid.children].forEach((card) => {
        if (card.classList.contains('is-open')) return;
        const text = card.querySelector('.er-card__text');
        const btn = card.querySelector('[data-er-expand]');
        if (text && btn) btn.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    }

    onClick(e) {
      const chip = e.target.closest('[data-er-filter]');
      if (chip) {
        this.filter = chip.dataset.erFilter;
        this.querySelectorAll('[data-er-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === chip)));
        this.shown = this.step;
        this.render(true);
        return;
      }
      if (e.target.closest('[data-er-more]')) {
        const before = this.grid.children.length;
        this.shown += this.step;
        this.render(false);
        const next = this.grid.children[before];
        if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); }
        return;
      }
      const expand = e.target.closest('[data-er-expand]');
      if (expand) {
        const card = expand.closest('[data-er-card]');
        const open = card.classList.toggle('is-open');
        expand.textContent = open ? 'Ler menos' : 'Ler mais';
        return;
      }
      const opener = e.target.closest('[data-er-open]');
      if (opener && !e.ctrlKey && !e.metaKey && typeof this.dialog.showModal === 'function') {
        e.preventDefault();
        this.opener = opener;
        this.open(Number(opener.dataset.erOpen), Number(opener.dataset.erMedia || 0));
        return;
      }
      if (e.target.closest('[data-er-close]') || e.target.matches('.er-lb__viewer, .er-lb__stage')) this.dialog.close();
      if (e.target.closest('[data-er-prev]')) this.go(-1);
      if (e.target.closest('[data-er-next]')) this.go(1);
      const thumb = e.target.closest('[data-er-thumb]');
      if (thumb) {
        this.pos = this.items.findIndex((it) => it.i === this.current.i && it.m === Number(thumb.dataset.erThumb));
        this.show();
      }
    }

    // ---- Lightbox: as fotos só são montadas quando o cliente abre ----
    buildItems(prefer) {
      const pool = this.matching.slice();
      if (!pool.includes(prefer)) pool.unshift(prefer);
      const items = [];
      pool.forEach((i) => this.data[i].m.forEach((_, m) => items.push({ i, m })));
      return items;
    }

    open(cardIndex, mediaIndex) {
      if (!this.data[cardIndex]) return;
      this.items = this.buildItems(cardIndex);
      this.pos = Math.max(0, this.items.findIndex((it) => it.i === cardIndex && it.m === mediaIndex));
      this.current = null;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.show();
    }

    go(dir) {
      if (!this.items?.length) return;
      this.pos = (this.pos + dir + this.items.length) % this.items.length;
      this.show();
    }

    mediaNode(item) {
      const rev = this.data[item.i];
      const m = rev.m[item.m];
      if (m.t === 'v') {
        const v = document.createElement('video');
        v.controls = true;
        v.playsInline = true;
        v.preload = 'metadata';
        if (m.p) v.poster = sized(m.p, 1200);
        (m.s || []).forEach((s) => { const src = document.createElement('source'); src.src = s.u; src.type = s.m; v.append(src); });
        return v;
      }
      const img = new Image();
      img.decoding = 'async';
      img.sizes = '(min-width: 990px) 60vw, 100vw';
      img.srcset = [800, 1200, 1600].map((w) => `${sized(m.u, w)} ${w}w`).join(', ');
      img.src = sized(m.u, 1600);
      if (m.w && m.h) { img.width = m.w; img.height = m.h; }
      img.alt = `Foto enviada por ${rev.n}`;
      return img;
    }

    show() {
      const item = this.items[this.pos];
      if (!item) return;
      const changedCard = !this.current || this.current.i !== item.i;
      this.current = item;
      this.stage.replaceChildren(this.mediaNode(item));
      this.counter.textContent = `${this.pos + 1} / ${this.items.length}`;
      this.querySelectorAll('.er-lb__nav').forEach((b) => { b.hidden = this.items.length < 2; });
      if (changedCard || !this.info.firstChild) this.renderInfo(item.i);
      this.info.querySelectorAll('[data-er-thumb]').forEach((t) => t.setAttribute('aria-current', String(Number(t.dataset.erThumb) === item.m)));
      const next = this.items[(this.pos + 1) % this.items.length];
      const nm = next && this.data[next.i].m[next.m];
      if (nm && nm.t !== 'v' && !next._pre) { const pre = new Image(); pre.src = sized(nm.u, 1600); next._pre = true; }
    }

    renderInfo(i) {
      const it = this.data[i];
      let html = this.metaHtml(it) + this.textHtml(it) + this.authorHtml(it);
      if (it.m.length > 1) {
        const thumbs = it.m.map((m, k) => {
          const src = still(m);
          return `<button type="button" class="er-lb__thumb" data-er-thumb="${k}" aria-label="Foto ${k + 1}">${src ? `<img src="${esc(sized(src, 240))}" alt="" loading="lazy">` : ''}</button>`;
        }).join('');
        html += `<div class="er-lb__thumbs">${thumbs}</div>`;
      }
      this.info.innerHTML = html;
      this.info.scrollTop = 0;
    }

    bindSwipe() {
      const viewer = this.querySelector('.er-lb__viewer');
      let x0 = null; let y0 = null;
      viewer.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; }, { passive: true });
      viewer.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0; const dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? 1 : -1);
      }, { passive: true });
      viewer.addEventListener('pointercancel', () => { x0 = null; });
    }
  }

  customElements.define('essenza-reviews', EssenzaReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essenza-vitrine"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-mv-collection]');
    if (!button) return;
    const section = button.closest('[data-essenza-collection]');
    section.querySelectorAll('[data-mv-collection]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    section.querySelectorAll('[data-mv-panel]').forEach(panel => { panel.hidden = panel.dataset.mvPanel !== button.dataset.mvCollection; });
  });

  (() => {
    const sections = document.querySelectorAll('[data-essenza-collection]');

    sections.forEach((section) => {
      const track = section.querySelector('[data-collection-track]');
      const previousButton = section.querySelector('[data-collection-previous]');
      const nextButton = section.querySelector('[data-collection-next]');

      if (!track || !previousButton || !nextButton) {
        return;
      }

      // Rola exatamente 1 card por clique, em vez de uma fração da largura
      const step = () => {
        const card = track.querySelector('.essenza-product-card');
        if (!card) return track.clientWidth * 0.85;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maximumScroll = track.scrollWidth - track.clientWidth;
        const scrollable = maximumScroll > 4;

        previousButton.disabled = !scrollable || track.scrollLeft <= 2;
        nextButton.disabled = !scrollable || track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.transition = this.dataset.transition === 'slide' ? 'slide' : 'fade';
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.delay = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
        this.index = 0;
        this.paused = false;
        this.visible = true;

        this.slides.forEach((slide, i) => {
          const active = i === 0;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (this.transition === 'slide' && !active) {
            slide.style.transform = 'translateX(100%)';
          }
        });

        const prev = this.querySelector('[data-hero-prev]');
        const next = this.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', () => this.navigate(-1));
        if (next) next.addEventListener('click', () => this.navigate(1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.jumpTo(i)));

        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });

        let startX = null;
        this.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const delta = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(delta) > 40) this.navigate(delta < 0 ? 1 : -1);
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
          });
          this.observer.observe(this);
        }

        if (window.Shopify && window.Shopify.designMode) {
          this.onSelect = (event) => {
            if (event.target.contains(this)) this.paused = true;
          };
          this.onDeselect = (event) => {
            if (event.target.contains(this)) this.paused = false;
          };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
        }

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }

      start() {
        this.stop();
        if (!this.autoplayEnabled) return;
        this.timer = setInterval(() => {
          if (this.paused || document.hidden || this.visible === false) return;
          this.goTo(this.index + 1, 1);
        }, this.delay);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }

      navigate(direction) {
        this.goTo(this.index + direction, direction);
        this.start();
      }

      jumpTo(target) {
        this.goTo(target, target > this.index ? 1 : -1);
        this.start();
      }

      goTo(rawIndex, direction) {
        const total = this.slides.length;
        const nextIndex = ((rawIndex % total) + total) % total;
        if (nextIndex === this.index) return;

        const current = this.slides[this.index];
        const upcoming = this.slides[nextIndex];

        if (this.transition === 'slide') {
          upcoming.style.transition = 'none';
          upcoming.style.transform = 'translateX(' + direction * 100 + '%)';
          void upcoming.offsetWidth;
          upcoming.style.transition = '';
          current.style.transform = 'translateX(' + direction * -100 + '%)';
          upcoming.style.transform = 'translateX(0)';
        }

        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        upcoming.classList.add('is-active');
        upcoming.setAttribute('aria-hidden', 'false');

        current.querySelectorAll('video').forEach((video) => video.pause());
        upcoming.querySelectorAll('video').forEach((video) => {
          const played = video.play();
          if (played && played.catch) played.catch(() => {});
        });

        this.index = nextIndex;
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          if (i === this.index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('essenza-proof-gallery')) {
  class EssenzaProofGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.bootFrame) return;
      this.bootFrame = requestAnimationFrame(() => {
        this.bootFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      if (!this.querySelector('.sps-shell')) { this.connectedCallback(); return; }
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = this.dataset.editor === 'true';
      this.paused = this.dataset.autoplay === 'false' || this.motion.matches;
      this.inView = true;
      this.hovered = false;
      this.interacting = false;
      this.pointerActive = false;
      this.editorSelected = false;
      this.photoLinks = Array.from(this.querySelectorAll('[data-original] [data-photo-id]'));
      this.dialog = this.querySelector('dialog');
      this.rows = Array.from(this.querySelectorAll('.sps-viewport')).map(view => ({ view, track: view.querySelector('.sps-track'), group: view.querySelector('[data-original]'), reverse: view.dataset.reverse === 'true', width: 0, position: 0 }));
      this.on(this, 'click', event => this.handleClick(event));
      this.on(this, 'focusin', () => this.syncAnimation());
      this.on(this, 'focusout', () => queueMicrotask(() => { if (this.isConnected) this.syncAnimation(); }));
      this.on(this.querySelector('.sps-gallery'), 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hover === 'true') { this.hovered = true; this.syncAnimation(); }
      });
      this.on(this.querySelector('.sps-gallery'), 'pointerleave', () => { this.hovered = false; this.syncAnimation(); });
      this.on(document, 'visibilitychange', () => this.syncAnimation());
      this.on(this.motion, 'change', () => { this.paused = true; this.rebuild(); });
      this.on(this, 'shopify:block:select', event => {
        this.editorSelected = true;
        this.syncAnimation();
        const card = Array.from(this.querySelectorAll('[data-original] [data-block-id]')).find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {
          const row = card.closest('.sps-viewport');
          row.scrollLeft += card.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - card.offsetWidth) / 2;
        }
      });
      this.on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.syncAnimation(); });
      this.on(document, 'pointerup', () => {
        if (this.pointerActive) { this.pointerActive = false; this.pauseForInteraction(); }
      });
      this.on(document, 'pointercancel', () => { this.pointerActive = false; this.syncAnimation(); });
      this.rows.forEach(row => {
        this.on(row.view, 'pointerdown', event => {
          this.pointerActive = true;
          this.pauseForInteraction();
          if (event.pointerType === 'mouse' && event.button === 0) row.drag = { x: event.clientX, left: row.view.scrollLeft, id: event.pointerId, moved: false };
        });
        this.on(row.view, 'pointermove', event => {
          if (!row.drag) return;
          const distance = event.clientX - row.drag.x;
          if (Math.abs(distance) > 6) {
            row.drag.moved = true;
            row.view.setPointerCapture(event.pointerId);
            event.preventDefault();
            row.view.scrollLeft = row.drag.left - distance;
          }
        });
        const endDrag = () => {
          if (row.drag?.moved) this.suppressClickUntil = performance.now() + 350;
          row.drag = null;
          this.pointerActive = false;
          this.pauseForInteraction();
        };
        this.on(row.view, 'pointerup', endDrag);
        this.on(row.view, 'pointercancel', endDrag);
        this.on(row.view, 'lostpointercapture', endDrag);
        this.on(row.view, 'dragstart', event => event.preventDefault());
        this.on(row.view, 'wheel', event => { if (event.deltaX || event.shiftKey) this.pauseForInteraction(); }, { passive: true });
        this.on(row.view, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.setPaused(true);
            this.stepRow(row, event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
      });
      if (this.dialog) {
        this.on(this.dialog, 'close', () => this.afterClose());
        this.on(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.on(this.dialog, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        });
        const stage = this.querySelector('.sps-dialog-stage');
        this.on(stage, 'touchstart', event => {
          this.swipe = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true });
        this.on(stage, 'touchend', event => {
          if (!this.swipe || event.changedTouches.length !== 1) return;
          const dx = event.changedTouches[0].clientX - this.swipe.x;
          const dy = event.changedTouches[0].clientY - this.swipe.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.showPhoto(this.photoIndex + (dx < 0 ? 1 : -1));
          this.swipe = null;
        }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.syncAnimation(); });
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.rebuild());
        });
        this.rows.forEach(row => { this.resizeObserver.observe(row.view); this.resizeObserver.observe(row.group); });
      } else {
        this.on(window, 'resize', () => this.rebuild());
      }
      this.dataset.ready = 'true';
      this.rebuild();
    }
    on(target, type, fn, options = {}) { target.addEventListener(type, fn, { ...options, signal: this.signal }); }
    cloneGroup(group) {
      const clone = group.cloneNode(true);
      clone.removeAttribute('data-original');
      clone.dataset.clone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('*').forEach(node => {
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
        node.removeAttribute('data-block-id');
      });
      clone.querySelectorAll('a').forEach(link => {
        const span = document.createElement('span');
        span.className = link.className;
        span.dataset.photoId = link.dataset.photoId;
        span.append(...link.childNodes);
        link.replaceWith(span);
      });
      clone.querySelectorAll('img').forEach(img => { img.alt = ''; img.draggable = false; });
      return clone;
    }
    rebuild() {
      if (!this.isConnected || !this.controller) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.rows.forEach(row => {
        const oldWidth = row.width;
        const phase = oldWidth ? ((row.view.scrollLeft % oldWidth) + oldWidth) % oldWidth / oldWidth : 0;
        row.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
        row.view.removeAttribute('data-loop');
        row.loop = this.dataset.autoplay !== 'false' && !this.motion.matches && row.group.children.length > 1;
        if (row.loop) {
          row.view.dataset.loop = 'true';
          row.width = row.group.getBoundingClientRect().width;
          if (!row.width) { row.loop = false; row.view.removeAttribute('data-loop'); return; }
          row.track.prepend(this.cloneGroup(row.group));
          const needed = Math.ceil(row.view.clientWidth / row.width) + 2;
          for (let i = 0; i < needed; i++) row.track.append(this.cloneGroup(row.group));
          row.position = row.width * (1 + phase);
          row.view.scrollLeft = row.position;
        } else {
          row.width = 0;
        }
      });
      this.syncAnimation();
    }
    pauseForInteraction() {
      this.interacting = true;
      clearTimeout(this.resumeTimer);
      this.syncAnimation();
      this.resumeTimer = setTimeout(() => {
        this.interacting = false;
        if (this.isConnected && this.controller) this.syncAnimation();
      }, 2000);
    }
    setPaused(value) {
      this.paused = value;
      if (!value) { clearTimeout(this.resumeTimer); this.interacting = false; }
      this.syncAnimation();
    }
    shouldRun() {
      const focusedRow = document.activeElement?.matches(':focus-visible') && this.rows.some(row => row.view.contains(document.activeElement));
      return !this.paused && !this.motion.matches && !this.editorSelected && !this.interacting && !this.pointerActive && this.inView && !this.hovered && !focusedRow && !this.dialog?.open && !document.hidden && this.rows.some(row => row.loop);
    }
    syncAnimation() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      if (!this.controller || !this.shouldRun()) return;
      this.rows.forEach(row => { row.position = row.view.scrollLeft; });
      this.lastTime = null;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (!this.shouldRun()) { this.frame = null; return; }
      const elapsed = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 50);
      this.lastTime = time;
      const duration = Math.max(10, Number(this.dataset.duration) || 30) * 1000;
      this.rows.forEach(row => {
        if (!row.loop) return;
        row.position += elapsed * row.width / duration * (row.reverse ? -1 : 1);
        row.position = row.width + ((row.position - row.width) % row.width + row.width) % row.width;
        row.view.scrollLeft = row.position;
      });
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    stepRow(row, direction) {
      const card = row.group.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(row.group).gap) || 0;
      if (row.loop) row.view.scrollLeft = row.width + ((row.view.scrollLeft - row.width) % row.width + row.width) % row.width;
      row.view.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    handleClick(event) {
      const action = event.target.closest('[data-action]');
      if (action) {
        const name = action.dataset.action;
        if (name === 'close') this.dialog?.close();
        if (name === 'photo-next') this.showPhoto(this.photoIndex + 1);
        if (name === 'photo-previous') this.showPhoto(this.photoIndex - 1);
        return;
      }
      const photo = event.target.closest('[data-photo-id]');
      if (!photo || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      event.preventDefault();
      if (performance.now() < (this.suppressClickUntil || 0)) return;
      const index = this.photoLinks.findIndex(link => link.dataset.photoId === photo.dataset.photoId);
      if (index < 0) return;
      this.returnFocus = photo.closest('[data-clone]') ? photo.closest('.sps-viewport') : photo;
      this.showPhoto(index);
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.lockScroll();
      }
      this.syncAnimation();
    }
    showPhoto(index) {
      if (!this.photoLinks.length || !this.dialog) return;
      this.photoIndex = (index + this.photoLinks.length) % this.photoLinks.length;
      const link = this.photoLinks[this.photoIndex];
      const stage = this.querySelector('.sps-dialog-stage');
      const error = this.querySelector('.sps-dialog-error');
      const image = new Image();
      image.alt = link.dataset.alt || '';
      image.decoding = 'async';
      image.draggable = false;
      error.hidden = true;
      image.addEventListener('error', () => {
        if (stage.firstElementChild === image) { error.hidden = false; image.hidden = true; }
      }, { once: true });
      stage.replaceChildren(image);
      image.src = link.href;
      const caption = this.querySelector('.sps-dialog-caption');
      caption.textContent = link.dataset.caption || '';
      caption.hidden = !caption.textContent;
      this.querySelector('.sps-counter').textContent = `${this.photoIndex + 1} / ${this.photoLinks.length}`;
      this.querySelectorAll('[data-action="photo-next"], [data-action="photo-previous"]').forEach(button => { button.hidden = this.photoLinks.length < 2; });
    }
    lockScroll() {
      if (this.locked) return;
      const type = this.constructor;
      if (!type.lockCount) {
        type.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      type.lockCount = (type.lockCount || 0) + 1;
      this.locked = true;
    }
    unlockScroll() {
      if (!this.locked) return;
      const type = this.constructor;
      type.lockCount = Math.max(0, (type.lockCount || 1) - 1);
      if (!type.lockCount) document.documentElement.style.overflow = type.oldOverflow || '';
      this.locked = false;
    }
    afterClose() {
      this.unlockScroll();
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      this.syncAnimation();
    }
    disconnectedCallback() {
      clearTimeout(this.resumeTimer);
      cancelAnimationFrame(this.bootFrame);
      this.bootFrame = null;
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resizeFrame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.unlockScroll();
      if (this.dialog?.open) this.dialog.close();
      this.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
    }
  }
  customElements.define('essenza-proof-gallery', EssenzaProofGallery);
}

  } catch(e) { console.error(e); }
})();
})();
